import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { AccessRoleDTO, AccessRoleFilterDTO, CompanyFilterDTO, PeopleFilterDTO, UserDTO, VacancyDTO, VacancyFilterDTO, ValueListDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField, TextFieldInput, KanbanList, ISwitchInputProps, IChipsSettingProps, IKanbanCardColumns } from '../../../shared/components';
import { VacancyMaintenance } from './VacancyMaintenance';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { ListId, LocalStorange } from '../../../shared/environment';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { Assessment } from './Assessment';
import { ResumeVacancyAssociate } from './ResumeVacancyAssociate';
import { Interview } from '../interview/Inteview';
import { HistoricalStatusTimeLine } from '../../historicalsphere/historicalStatus/HistoricalStatusTimeLine';
import { VacancyReport } from './VacancyReport';
import { Comment } from '../../infosphere/comment/Comment';
import { useTranslation } from 'react-i18next';

export const Vacancy: React.FC = () => {

    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    const [jobTitleList, setJobTitleList] = useState<ValueListDTO[]>([]);
    const [seniorityList, setSeniorityList] = useState<ValueListDTO[]>([]);
    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [requesterList, setRequesterList] = useState<UserDTO[]>([]);
    const [managerList, setManagerList] = useState<UserDTO[]>([]);
    const [recruiterList, setRecruiterList] = useState<UserDTO[]>([]);
    const [vacancyList, setVacancyList] = useState<VacancyDTO[]>([]);
    const [vacancyFilterDTO, setVacancyFilterDTO] = useState<VacancyFilterDTO>();

    const [associateResume, setAssociateResume] = useState('');
    const [associateResumeForCustomer, setAssociateResumeForCustomer] = useState('');
    const [assessment, setAssessment] = useState('');
    const [interview, setInterview] = useState('');
    const [historicalStatusTimeLine, setHistoricalStatusTimeline] = useState('');
    const [vacancyReport, setVacancyReport] = useState('');
    const [comment, setComment] = useState('');

    const [cardMoved, setCardMoved] = useState<any>();
    const [checkedKanban, setCheckedKanban] = useState(true);

    const [actionExecuted, setActionExecuted] = useState(false);

    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setVacancyFilterDTO({
            ...vacancyFilterDTO,
            name: '',
            code: '',
            jobTitleId: '',
            seniorityId: '',
            typeId: '',
            statusId: '',
            requesterId: '',
            managerId: '',
            recruiterId: '',
            companyId: ''
        } as VacancyFilterDTO);

        handleListGetAll(ListId.talentsphere.vacancy.jobTitleId, setJobTitleList);
        handleListGetAll(ListId.talentsphere.vacancy.seniorityId, setSeniorityList);
        handleListGetAll(ListId.talentsphere.vacancy.typeId, setTypeList);
        handleListGetAll(ListId.talentsphere.vacancy.statusId, setStatusList);

        handleCompanyGetAll();
        handleRequesterGetAllAsync();
        handleServiceManagerGetAllAsync();
        handleRecruiterGetAllAsync();

        handleGetPermission(ListId.talentsphere.vacancyId, setAccessRolePermissionDTO);
    }, []);

    useEffect(() => {
        handleVacancyGetAllViewAsync();
    }, [vacancyFilterDTO]);

    useEffect(() => {
        if (actionExecuted)
            handleVacancyGetAllViewAsync();
    }, [actionExecuted]);

    useEffect(() => {
        handleRequesterGetAllAsync();
    }, [vacancyFilterDTO?.companyId]);

    useEffect(() => {
        handleMoveTaskKanbanAsync();
    }, [cardMoved]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync',accessRoleFilterDTO, setActionExecuted, setLoading, undefined,  setList);
    }, []);

    const handleMoveTaskKanbanAsync = useCallback(async () => {
        if (cardMoved === undefined || cardMoved.id === undefined || cardMoved.statusId === undefined) {
            return;
        }
        const vacancyId = cardMoved.id;
        const statusId = cardMoved.statusId;
        const index = cardMoved.index;

        const vacancyDTO = {
            id: vacancyId,
            statusId: statusId,
            kanbanIndex: index,
            updatedById: userInfo.user.Id
        };
        GenericService.PostGenericAsync1('talentsphere.vacancy', 'MoveTaskKanbanAsync', vacancyDTO, setActionExecuted, setLoading, showMessage);
    }, [cardMoved]);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            where: `businessRelationshipTypeId IN ('${ListId.corpsphere.company.businessRelationshipType.customer}', '${ListId.corpsphere.company.businessRelationshipType.prospection}', '${ListId.corpsphere.company.businessRelationshipType.businessPartner}')`,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleRequesterGetAllAsync = useCallback(async () => {
        if (vacancyFilterDTO?.companyId === undefined || vacancyFilterDTO.companyId === '') {
            return;
        }
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: vacancyFilterDTO?.companyId,
            orderBy: 'fullName ASC',
            where: `typeId NOT IN ('${ListId.corpsphere.people.type.serviceAccount}')`
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setRequesterList, showMessage);
    }, [vacancyFilterDTO?.companyId]);

    const handleServiceManagerGetAllAsync = useCallback(async () => {
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: vacancyFilterDTO?.companyId,
            orderBy: 'fullName ASC',
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setManagerList, showMessage);
    }, []);

    const handleRecruiterGetAllAsync = useCallback(async () => {
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            orderBy: 'fullName ASC',
            where: `typeId NOT IN ('${ListId.corpsphere.people.type.serviceAccount}') AND jobTitleId IN ('${ListId.talentsphere.vacancy.jobTitle.recruitmentManagerId}', '${ListId.talentsphere.vacancy.jobTitle.recruiterId}')`
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setRecruiterList, showMessage);
    }, []);
    const handleVacancyGetAllViewAsync = useCallback(async () => {
        if (vacancyFilterDTO === undefined)
            return;
        if(accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if(!accessRolePermissionDTO?.allowGetAllView) {
            showMessage(t('message.allowGetAllView'), 'info');
            return;
        }
        GenericService.GetAllViewAsync1('talentsphere.vacancy', vacancyFilterDTO, setActionExecuted, setLoading, setVacancyList, showMessage, true);
    }, [vacancyFilterDTO, accessRolePermissionDTO]);

    const handleClearFilterClick = () => {
        setVacancyFilterDTO({
            ...vacancyFilterDTO,
            name: '',
            code: '',
            jobTitleId: '',
            seniorityId: '',
            typeId: '',
            statusId: '',
            requesterId: '',
            managerId: '',
            recruiterId: '',
            companyId: ''
        } as VacancyFilterDTO);
    };

    function handleSearchClick() {
        handleVacancyGetAllViewAsync();
    }

    const handleNew = () => {
        if(!accessRolePermissionDTO?.allowAdd) {
            showMessage(t('message.allowAdd'), 'info');
            return;
        }
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleViewDetatils = (data: string) => {
        if(!accessRolePermissionDTO?.allowGetById) {
            showMessage(t('message.allowGetById'), 'info');
            return;
        }
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleDelete = (data: string) => {
        if(!accessRolePermissionDTO?.allowDelete) {
            showMessage(t('message.allowDelete'), 'info');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord(data);
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleAssessment = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment(data);
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleResumeSelect = (data: any) => {
        if(data.statusId === ListId.talentsphere.vacancy.status.newRequestId) {
            showMessage(t('vacancy.message.handleResumeSelect'), 'warning');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume(data);
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleResumeSelectForCustomer = (data: any) => {
        if(data.statusId === ListId.talentsphere.vacancy.status.newRequestId) {
            showMessage(t('vacancy.message.handleResumeSelect'), 'warning');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResumeForCustomer(data);
        setAssociateResume('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleInterview = (data: any) => {
        if(data.statusId === ListId.talentsphere.vacancy.status.newRequestId) {
            showMessage(t('vacancy.message.handleResumeSelect'), 'warning');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview(data.id);
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment('');
    };

    const handleHistoricalTimeLine = (data: any) => {
        if(data.statusId === ListId.talentsphere.vacancy.status.newRequestId) {
            showMessage(t('vacancy.message.handleResumeSelect'), 'warning');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline(data.id);
        setVacancyReport('');
        setComment('');
    };

    const handleVacancyReport = () => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('data');
        setComment('');
    };

    const handleComment = (data: any) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setAssessment('');
        setAssociateResume('');
        setAssociateResumeForCustomer('');
        setInterview('');
        setHistoricalStatusTimeline('');
        setVacancyReport('');
        setComment(data.id);
    };

    const toolBarActions: IDialogActions[] = [
        { id: 'new', text: t('vacancy.button.new'), icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
        { id: 'report', text: t('vacancy.button.report'), icon: 'list_outlined', iconColor: 'primary', setAction: handleVacancyReport },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: t('vacancy.cardActions.viewDetails'), icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'interview', toolTip: t('vacancy.cardActions.interview'), icon: 'voice_chat_outlined', iconColor: 'success', setAction: handleInterview },
        { id: 'associateResumes', toolTip: t('vacancy.cardActions.associatedResumes'), icon: 'view_kanban_outlined', iconColor: 'info', setAction: handleResumeSelect },
        { id: 'associateResumesForCustomer', toolTip: t('vacancy.cardActions.associatedResumesForCustomer'), icon: 'view_kanban_outlined', iconColor: 'warning', setAction: handleResumeSelectForCustomer },
        { id: 'comment', toolTip: t('vacancy.cardActions.comments'), icon: 'comment_outlined', iconColor: 'success', setAction: handleComment },
        { id: 'assessment', toolTip: t('vacancy.cardActions.viewQuestions'), icon: 'rule_outlined', iconColor: 'info', setAction: handleAssessment },
        { id: 'timeline', toolTip: t('vacancy.cardActions.timeline'), icon: 'timeline_outlined', iconColor: 'success', setAction: handleHistoricalTimeLine },
        { id: 'delete', toolTip: t('vacancy.cardActions.delete'), icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFilters: IChipFilter[] = [
        { label: t('vacancy.chipFilters.totalRecords'), value: vacancyList.length },
        { label: t('vacancy.chipFilters.code'), value: vacancyFilterDTO?.code },
        { label: t('vacancy.chipFilters.company'), value: companyList.find(x => x.id === vacancyFilterDTO?.companyId)?.name },
        { label: t('vacancy.chipFilters.jobTitle'), value: jobTitleList.find(x => x.id === vacancyFilterDTO?.jobTitleId)?.value },
        { label: t('vacancy.chipFilters.seniority'), value: seniorityList.find(x => x.id === vacancyFilterDTO?.seniorityId)?.value },
        { label: t('vacancy.chipFilters.type'), value: typeList.find(x => x.id === vacancyFilterDTO?.typeId)?.value },
        { label: t('vacancy.chipFilters.status'), value: statusList.find(x => x.id === vacancyFilterDTO?.statusId)?.value },
        { label: t('vacancy.chipFilters.manager'), value: managerList.find(x => x.id === vacancyFilterDTO?.managerId)?.userName },
        { label: t('vacancy.chipFilters.requester'), value: requesterList.find(x => x.id === vacancyFilterDTO?.requesterId)?.userName },
        { label: t('vacancy.chipFilters.recruiter'), value: recruiterList.find(x => x.id === vacancyFilterDTO?.recruiterId)?.userName },
    ];

    const chipStatus : IChipsSettingProps[] = [
        { value: t('vacancy.chipsSettingProps.newRequest'), iconName: 'person_add_alt_outlined', iconColor: 'primary' },
        { value: t('vacancy.chipsSettingProps.inProgress'), iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: t('vacancy.chipsSettingProps.hired'), iconName: 'person_outlined', iconColor: 'success' },
        { value: t('vacancy.chipsSettingProps.canceledByTheContractor'), iconName: 'person_off_outlined', iconColor: 'error' },
        { value: t('vacancy.chipsSettingProps.suspendedByTheContractor'), iconName: 'person_add_disabled_outlined', iconColor: 'warning' },
        { value: t('vacancy.chipsSettingProps.lost'), iconName: 'person_off_outlined', iconColor: 'error' }
    ];

    const resumesCount : IChipsSettingProps[] = [
        { value: '0', iconName: 'person_alt_outlined', iconColor: 'error', iconNameDefault: 'person_add_alt_outlined', iconColorDefault: 'success' },
        { value: '1', iconName: 'person_add_alt_outlined', iconColor: 'error', iconNameDefault: 'person_add_alt_outlined', iconColorDefault: 'success' },
        { value: '2', iconName: 'person_add_alt_outlined', iconColor: 'error', iconNameDefault: 'person_add_alt_outlined', iconColorDefault: 'success' },
        { value: '3', iconName: 'person_add_alt_outlined', iconColor: 'error', iconNameDefault: 'person_add_alt_outlined', iconColorDefault: 'success' },
        { value: '4', iconName: 'person_add_alt_outlined', iconColor: 'warning', iconNameDefault: 'person_add_alt_outlined', iconColorDefault: 'success' },
    ];

    const openDays : IChipsSettingProps[] = [
        { value: `0 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `1 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `2 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `3 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `4 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `5 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'success', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `6 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'warning', iconNameDefault: '', iconColorDefault: 'error' },
        { value: `7 ${t('vacancy.chipsSettingProps.days')}`, iconName: '', iconColor: 'warning', iconNameDefault: '', iconColorDefault: 'error' },
    ];

    const columns: ICardColumns[] = [
        { field: 'code', label: t('vacancy.columns.code'), size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'company', label: t('vacancy.columns.company'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'jobTitle', label: t('vacancy.columns.jobTitle'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'seniority', label: t('vacancy.columns.seniority'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'numberOfVacancies', label: t('vacancy.columns.numberOfVacancies'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'status', label: t('vacancy.columns.status'), size: 2, type: 'text', visible: true, isChip: true, chipSettings: chipStatus, hasFieldLine: false, hasToolTip: true },
        { field: 'manager', label: t('vacancy.columns.manager'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'recruiter', label: t('vacancy.columns.recruiter'), size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'openingDateTime', label: t('vacancy.columns.openingDate'), size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'closingDateTime', label: t('vacancy.columns.closingDate'), size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'openDays', label: t('vacancy.columns.openDays'), size: 2, type: 'text', visible: true, isChip: true, chipSettings: openDays, hasFieldLine: false, hasToolTip: true },
        { field: 'resumes', label: t('vacancy.columns.resumes'), size: 2, type: 'text', visible: true, isChip: true, chipSettings: resumesCount, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: t('vacancy.columns.name'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true, noWrap: false },

    ];

    const kanbanColumns: IKanbanCardColumns[] = [
        { field: 'name', label: t('vacancy.columns.name'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true, noWrap: false },
        { field: 'code', label: t('vacancy.columns.code'), size: 12, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'company', label: t('vacancy.columns.company'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'manager', label: t('vacancy.columns.manager'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'recruiter', label: t('vacancy.columns.recruiter'), size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'openingDateTime', label: t('vacancy.columns.openingDate'), size: 6, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'closingDateTime', label: t('vacancy.columns.closingDate'), size: 6, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'openDays', label: t('vacancy.columns.openDays'), size: 6, type: 'text', visible: true, isChip: true, chipSettings: openDays, hasFieldLine: false, hasToolTip: true },
        { field: 'resumes', label: t('vacancy.columns.resumes'), size: 6, type: 'text', visible: true, isChip: true, chipSettings: resumesCount, hasFieldLine: false, hasToolTip: true },
    ];

    const kanbanSwitch: ISwitchInputProps = {
        id: 'vacancy.switch', label: t('vacancy.maintenanceButton.kanbanList'), checked: checkedKanban, setChecked: setCheckedKanban, disabled: false, autoFocus: false, color: 'info', size: 'small', labelPlacement: 'end'
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title={t('vacancy.listName')}>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                    kanbanSwitch={kanbanSwitch}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='name'
                                label={t('vacancy.filter.name')}
                                placeholder={t('vacancy.filter.name')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.name}
                                obj={vacancyFilterDTO}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='code'
                                label={t('vacancy.filter.code')}
                                placeholder={t('vacancy.filter.code')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.code}
                                obj={vacancyFilterDTO}
                                maxLength={20}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='companyId'
                                label={t('vacancy.filter.company')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.companyId}
                                obj={vacancyFilterDTO}
                                valueList={companyList}
                                hasNoneSelect={true}
                                searchable={true}
                                labelKey='name'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='requesterId'
                                label={t('vacancy.filter.requester')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.requesterId}
                                obj={vacancyFilterDTO}
                                valueList={requesterList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='managerId'
                                label={t('vacancy.filter.manager')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.managerId}
                                obj={vacancyFilterDTO}
                                valueList={managerList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='jobTitleId'
                                label={t('vacancy.filter.jobTitle')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.jobTitleId}
                                obj={vacancyFilterDTO}
                                valueList={jobTitleList}
                                hasNoneSelect={true}
                                searchable={true}
                                labelKey='value'
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='seniorityId'
                                label={t('vacancy.filter.seniority')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.seniorityId}
                                obj={vacancyFilterDTO}
                                valueList={seniorityList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='typeId'
                                label={t('vacancy.filter.type')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.typeId}
                                obj={vacancyFilterDTO}
                                valueList={typeList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='statusId'
                                label={t('vacancy.filter.status')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.statusId}
                                obj={vacancyFilterDTO}
                                valueList={statusList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='recruiterId'
                                label={t('vacancy.filter.recruiter')}
                                setValue={setVacancyFilterDTO}
                                value={vacancyFilterDTO?.recruiterId}
                                obj={vacancyFilterDTO}
                                valueList={recruiterList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                            />
                        </Grid>
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                {checkedKanban ? (
                    <Box sx={{ display: 'flex', height: 'calc(100dvh - 200px)', minHeight: 0, width: '100%', overflow: 'hidden' }}>
                        <KanbanList
                            identifierField='statusId'
                            cards={vacancyList}
                            attributes={kanbanColumns}
                            statusList={statusList}
                            setRowExpanded={setExpandedData}
                            setCardMoved={setCardMoved}
                            actions={cardActions}
                            cardSize={2}
                        />
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', maxHeight: '80vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                        <CardList
                            columns={columns}
                            rows={vacancyList}
                            actions={cardActions}
                            cardSize={12}
                            hasChildren={false}
                            setRowExpanded={() => void undefined}
                        />
                    </Box>
                )}
                {newRecord && (
                    <VacancyMaintenance
                        data={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {editRecord && (
                    <VacancyMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'talentsphere.vacancy'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                    indexAttributeLabel={2}
                />)}
                {assessment && (
                    <Assessment
                        data={assessment}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {associateResume && (
                    <ResumeVacancyAssociate
                        data={associateResume}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        actionExecuted={actionExecuted}
                        isCustomer={false}
                    />
                )}
                {associateResumeForCustomer && (
                    <ResumeVacancyAssociate
                        data={associateResumeForCustomer}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        actionExecuted={actionExecuted}
                        isCustomer={true}
                    />
                )}
                {interview && (
                    <Interview
                        vacancyId={interview}
                        resumeId={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        actionExecuted={actionExecuted}
                    />
                )}
                {historicalStatusTimeLine && (
                    <HistoricalStatusTimeLine
                        title={t('vacancy.historicalStatusTimeLine.statusHistorical')}
                        ownerId={historicalStatusTimeLine}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        chipSettings={chipStatus}
                    />
                )}
                {vacancyReport && (
                    <VacancyReport
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {comment && (
                    <Comment
                        ownerId={comment}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        actionExecuted={actionExecuted}
                    />
                )}
            </LayoutDashboard>
        </React.Fragment >
    );
};
